import { Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { searchProjectAdvance } from '../../api/project-item';

function ProjectSelectAdvance({ value = null, onChange, filters = {}, currentSelection = {}, ...otherProps }) {
    const debounceTimeout = 200
    const selectedOption = currentSelection?.value && currentSelection.value === value ? [{ value: currentSelection?.value, label: currentSelection?.label }] : []
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState(selectedOption);
    const fetchRef = useRef(0);

    useEffect(() => {
        debounceFetcher()
    }, [filters])

    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            fetchRef.current += 1;
            const fetchId = fetchRef.current;
            setOptions(selectedOption);
            setFetching(true);
            searchProjectAdvance(value, filters).then((newOptions) => {
                if (fetchId !== fetchRef.current) {
                    // for fetch callback order
                    return;
                }
                if (!selectedOption.some(({ value }) => value === currentSelection.value)) {
                    setOptions([...selectedOption, ...newOptions]);
                }
                else {
                    setOptions([...newOptions]);
                }
                setFetching(false);
            });
        };
        return debounce(loadOptions, debounceTimeout);
    }, [filters, currentSelection, searchProjectAdvance, debounceTimeout]);

    return (
        <Select
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            options={options}
            onChange={onChange}
            value={value}
            placeholder="Select Project"
            showSearch
            allowClear
            {...otherProps}
        />
    );
}

ProjectSelectAdvance.propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
    filters: PropTypes.object,
    currentSelection: PropTypes.object
    // currentSelection: PropTypes.shape({
    //     id: PropTypes.number.isRequired,
    //     company: PropTypes.string.isRequired
    // })
}

export default ProjectSelectAdvance;